export { default } from './web/ClipboardModule';
//# sourceMappingURL=ExpoClipboard.web.js.map